import { HttpErrorResponse } from '@angular/common/http';
import { AccountValidationResult } from '../../models/account';
var VerifyEmailPageComponent = /** @class */ (function () {
    function VerifyEmailPageComponent() {
    }
    Object.defineProperty(VerifyEmailPageComponent.prototype, "hasError", {
        get: function () {
            return !!this.verifyEmailError;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerifyEmailPageComponent.prototype, "errorMessage", {
        get: function () {
            if (this.verifyEmailError instanceof HttpErrorResponse) {
                return this.verifyEmailError.error.message;
            }
            else {
                return this.verifyEmailError.message;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerifyEmailPageComponent.prototype, "accountValidationNeeded", {
        get: function () {
            return this.accountValidationResult.validated === false;
        },
        enumerable: true,
        configurable: true
    });
    return VerifyEmailPageComponent;
}());
export { VerifyEmailPageComponent };
